import * as React from 'react';

export default class UserListItem extends React.Component {
  render = () => {
    const { nombreUsuario, email } = this.props;

    return (
      <div className="list-group-item hover-background-color">
        <div className="col-md-12 col-lg-12 col-12 col-sm-12 d-md-block">
          <div className="row">

            <div className="col-md-3 col-lg-3">
              <h6 className="box-title m-b-5 font-weight-bold" >{nombreUsuario}</h6>
            </div>

            <div className="col-md-4 col-lg-4">
              <small className=" font-14  applyFont">
                <i className="fas fa-envelope" /> {email}
              </small>
            </div>

          </div>
        </div>
      </div>
    );
  }
}